module.exports = __webpack_public_path__ + "static/media/0-4.c78673ab.svg";